<template src="./index.html" />

<script>
import {
  BButton, BCard, BCardBody, BCardHeader, BCardTitle, BCol, BRow, BContainer, BImg, BFormInput, BFormDatepicker, BFormGroup, BForm, BFormFile,
} from 'bootstrap-vue'
import { getUser } from '@/auth/utils'
import { mapActions, mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { VueGoodTable } from 'vue-good-table'
import dayjs from 'dayjs'

export default {
  name: 'Index',
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BContainer,
    BImg,
    BFormInput,
    BFormDatepicker,
    BFormGroup,
    BForm,
    vSelect,
    BFormFile,
    VueGoodTable,
  },

  data() {
    return {
      table: {
        columns: [
          {
            label: "STT",
            field: "index",
            width: "80px",
            sortable: false,
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            label: 'Học phần',
            field: 'subjectName',
            filterOptions: {
              enabled: true,
              trigger: 'enter',
            },
            thClass: 'text-center',
          },
          {
            label: 'Số tiết',
            field: 'totalCreditNum',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            label: 'Phòng thi',
            field: 'roomName',
            filterOptions: {
              enabled: true,
              trigger: 'enter',
            },
            thClass: 'text-center',
            tdClass: 'text-left',
          },
          {
            label: 'Thời gian bắt đầu',
            field: 'startAt',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            label: 'Thời gian kết thúc',
            field: 'endAt',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
        ],
        dataRows: [],
        paginationOptions: {
          enabled: false,
        },
      },
      user: getUser(),
      filter: {
        courseSemestersId: null,
        studentId: null,
        subjectName: null,
        roomName: null,
      },
    }
  },

  computed: {
    // calculate data from init data
    ...mapGetters({
      dataSources: 'student/examinationRooms',
    }),
    formattedRows() {
      return this.dataSources.map(row => ({
        ...row,
        startAt: row.startAt ? dayjs(row.startAt).format('DD/MM/YYYY HH:mm') : 'Chưa cập nhật',
        endAt: row.endAt ? dayjs(row.endAt).format('DD/MM/YYYY HH:mm') : 'Chưa cập nhật',
      }))
    },
    formattedRows() {
  const start = (this.table.paginationOptions.currentPage - 1 || 0) * (this.table.paginationOptions.perPage || 10)
  return this.table.dataRows.map((row, index) => ({
    ...row,
    stt: start + index + 1,
    startAt: row.startAt ? dayjs(row.startAt).format('DD/MM/YYYY HH:mm') : 'Chưa cập nhật',
    endAt: row.endAt ? dayjs(row.endAt).format('DD/MM/YYYY HH:mm') : 'Chưa cập nhật',
  }))
},
    courseSemesterId() {
      const { programmes, portalProgrammeId } = this.user
      if (!portalProgrammeId || programmes.length === 0) return null
      const found = programmes.find(element => element.id === portalProgrammeId)
      return found ? found.courseSemesterId : null
    },
    semesterName() {
      const { programmes, portalProgrammeId } = this.user
      if (!portalProgrammeId || programmes.length === 0) return ''
      const found = programmes.find(element => element.id === portalProgrammeId)
      return found ? found.semesterName : ''
    },
  },

  async created() {
    await this.getInitData()
  },
  methods: {
    // handle even
    ...mapActions({
      getDataSource: 'student/getListExamination',
    }),

    async getInitData() {
      this.filter.courseSemestersId = this.courseSemesterId
      this.filter.studentId = this.user.studentId
      await this.getDataSource(this.filter)
      this.table.dataRows = this.dataSources
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'subjectName')) this.updateParams({ subjectName: columnFilters.subjectName })
      if (Object.hasOwn(columnFilters, 'roomName')) this.updateParams({ roomName: columnFilters.roomName })
      await this.getInitData()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
.title-text{
  font-size: 20px;
  color: red;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
